<div class="kcDms-Folder-Location-pop-up-container cmn-modal-dsgn" role="document">
    <form>
        <div class="col-sm-12 p-0">
            <div class="cmn-modal-header">
                <h3 class="modal-header-title">
                    Template location
                </h3>
            </div>

            <div class="cmn-modal-content">
                <div class="col-sm-12 pl-0 pr-0 mb-2">
                    <div class="d-flex justify-content-between">
                        <div class="mt-2 d-flex justify-content-start">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="cliencontact-title">
                                    <div>
                                        <div class="breadcrumb-wrapper">
                                            <ul class="breadcrumb" *ngIf="isNonSharePoint">

                                                <li>
                                                    <a class="home" (click)="homeBreadCrumbClicked()">
                                                        <img src="assets/images/home.svg" alt="home">
                                                    </a>
                                                </li>
                                                <li
                                                    *ngFor="let item of dmsBreadcrumbs; let i = index">
                                                    <a href="javascript:void(0);" (click)="dmsBreadcrumbClick(item, i)">
                                                        {{ item.name }}
                                                    </a>
                                                </li>
                                            </ul>

                                            <ul class="breadcrumb" *ngIf="!isNonSharePoint">
                                                <li>
                                                    <a class="home" (click)="homeBreadCrumbClicked()">
                                                        <img src="assets/images/home.svg" alt="home">
                                                    </a>
                                                </li>

                                                <ng-container *ngIf="breadcrumbData.length > 0">
                                                    <li *ngFor="let item of breadcrumbData; let i = index">
                                                        <a href="javascript:void(0);" (click)="folderPath(item.Id)">
                                                            {{ item.FolderName }}
                                                        </a>
                                                    </li>
                                                </ng-container>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-end cmn-grid-top-right-filters">
                            <div class="grid-search-filter" tabindex="1">
                                <img src="../../../assets/img/search-icon/search_icon.svg"
                                    class="img-responsive" />

                                <input class="form-control searchtext"
                                    type="search"
                                    placeholder="Search"
                                    aria-controls="dataTable"
                                    aria-label="Search"
                                    aria-describedby="basic-addon2"
                                    [(ngModel)]="searchKeyword"
                                    name="searchKeyword"
                                    (keyup)="searchKyePress(searchKeyword)"
                                    (search)="searchKyePress(searchKeyword)"
                                    (input)="onSearchInputClear()" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="linkfile-height">
                    <div class="linkfile-table">
                        <div class="col-12 p-0">
                            <div *ngIf="temptemplatedatList?.length > 0" class="cmn-table-design status-hover-table client-list-grid">
                                <div>
                                    <ejs-grid
                                        #grid
                                        [dataSource]="temptemplatedatList"
                                        [allowResizing]="true"
                                        [allowReordering]="false"
                                        [allowSorting]="true"
                                        [showColumnChooser]="false"
                                        [allowGrouping]="false"
                                        [showColumnMenu]="false"
                                        [groupSettings]="groupOptions"
                                        [enableInfiniteScrolling]="true"
                                        [infiniteScrollSettings]="infiniteOptions"
                                        [pageSettings]="options"
                                        [allowFiltering]="false"
                                        [enableAltRow]="true"
                                        [allowSelection]="false">
                                        <e-columns>
                                            <e-column field="name" headerText="Name" textAlign="Left" width="200">
                                                <ng-template #template let-data>
                                                    <span class="cursor-pointer PaddingLeft" matTooltipClass="cmn-tooltip-template" matTooltip="{{ data.name }}"
                                                        (click)="handleItemClick(data)">
                                                        <span class="icon-align-left">
                                                            <img [src]="data.fileImageUrl" class="img-responsive" />
                                                            {{ data.name }}
                                                        </span>
                                                    </span>
                                                </ng-template>
                                            </e-column>
                                        </e-columns>
                                    </ejs-grid>
                                </div>
                            </div>

                            <!-- NO RECORDS -->
                            <div *ngIf="temptemplatedatList?.length === 0" class="d-flex justify-content-center align-items-center fs-5 m-hx-400">
                                No records found.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="cmn-modal-footer">
                <button type="button" mat-button class="cmn-blue-btn mr-2" [disabled]="!(breadcrumbData?.length > 1)">
                    Select
                </button>
                <button type="button" class="cmn-inverse-btn" mat-button data-dismiss="modal" (click)="closePopUp()">
                    Cancel
                </button>
            </div>
        </div>
    </form>
</div>